import React, { useState, useEffect } from "react";
import { cn } from "utils";
import { ChevronUp } from "lucide-react";

export default function ScrollToTopButton({ threshold = 1500 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.pageYOffset > threshold);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={cn(
        "fixed bottom-8 right-8 p-3 rounded-full bg-blue-500 text-white shadow-lg transform transition-opacity duration-300",
        {
          "opacity-100": visible,
          "opacity-0 pointer-events-none": !visible,
        }
      )}
      aria-label="Scroll to top"
    >
      <ChevronUp />
    </button>
  );
}
